module.exports = __webpack_public_path__ + "static/media/volleyball-ball.f0b0d684.svg";